import { PUSH, REMOVE, DefaultStickTime } from "./index";

export const ToasterActions = {
    NewInfo: (message, title, stick = DefaultStickTime) => ({
        type: PUSH,
        appearance: "info",
        title,
        message,
        stick,
    }),
    NewOK: (message, title, stick = DefaultStickTime) => ({
        type: PUSH,
        appearance: "ok",
        title,
        message,
        stick,
    }),
    NewWarning: (message, title, stick = DefaultStickTime) => ({
        type: PUSH,
        appearance: "warning",
        title,
        message,
        stick,
    }),
    NewError: (message, title, stick = DefaultStickTime) => ({
        type: PUSH,
        appearance: "error",
        title,
        message,
        stick,
    }),
    NewLoanRequest: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count: count,
        cpty: cpty,
        pushType: "request",
        title: "New Loan Request",
        stick: DefaultStickTime,
    }),
    NewOffer: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count: count,
        cpty: cpty,
        pushType: "offer",
        title: "New Offer",
        stick: DefaultStickTime,
    }),
    NewRecall: (recall) => ({
        type: PUSH,
        appearance: "warning",
        details: recall,
        cpty: recall.lender?.name,
        pushType: "recall",
        title: "New Recall",
        stick: 0, // Recall notifications will not disappear automatically
    }),
    RecallCanceled: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        cpty,
        count,
        pushType: "recallCanceled",
        title: "Cancel",
        stick: DefaultStickTime, // Recall notifications will not disappear automatically
    }),
    RecallDisputed: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        cpty,
        count,
        pushType: "recallDisputed",
        title: "Dispute",
        stick: DefaultStickTime, // Recall notifications will not disappear automatically
    }),
    NewAutoMatch: (count) => ({
        type: PUSH,
        appearance: "ok",
        count: count,
        cpty: "blank",
        pushType: "match",
        title: "Auto-Match",
        stick: DefaultStickTime,
    }),
    NewAccept: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count: count,
        cpty: cpty,
        pushType: "accept",
        title: "Accepted",
        stick: DefaultStickTime,
    }),
    NewReject: (cpty, count) => ({
        type: PUSH,
        appearance: "warning",
        count: count,
        cpty: cpty,
        pushType: "reject",
        title: "Reject",
        stick: DefaultStickTime,
    }),
    NewFork: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count: count,
        cpty: cpty,
        pushType: "fork",
        title: "Forked",
        stick: DefaultStickTime,
    }),
    NewUpgrade: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count: count,
        cpty: cpty,
        pushType: "upgrade",
        title: "Upgraded",
        stick: DefaultStickTime,
    }),
    NewUpgradeRequest: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count: count,
        cpty: cpty,
        pushType: "upgrade_request",
        title: "EAs Upgrade Request ",
        stick: DefaultStickTime,
    }),
    NewRelease: (cpty, count) => ({
        type: PUSH,
        appearance: "warning",
        count: count,
        cpty: cpty,
        pushType: "release",
        title: "Released",
        stick: DefaultStickTime,
    }),
    NewConfirmation: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count: count,
        cpty: cpty,
        pushType: "confirm",
        title: "Confirmed",
        stick: DefaultStickTime,
    }),
    ConfirmationCanceled: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count,
        cpty,
        pushType: "canceled",
        title: "Canceled",
        stick: DefaultStickTime,
    }),
    ConfirmationModified: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count,
        cpty,
        pushType: "modified",
        title: "Modified",
        stick: DefaultStickTime,
    }),
    NewAvailability: (cpty, count) => ({
        type: PUSH,
        appearance: "ok",
        count,
        cpty,
        pushType: "availability",
        title: "New Inbox Messages",
        stick: DefaultStickTime,
    }),
    Remove: (id) => ({ type: REMOVE, id }),
};
